import React from "react";
import "./style.scss";

import vector3 from "../../../../../static/img/vector-3.svg";
import vector4 from "../../../../../static/img/vector-4.svg";
import vector5 from "../../../../../static/img/vector-5.svg";
import vector6 from "../../../../../static/img/vector-6.svg";
import vector7 from "../../../../../static/img/vector-7.svg";
import vector8 from "../../../../../static/img/vector-8.svg";

const FEATURES = [
  {
    icon: vector3,
    title: "Say Goodbye to Spreadsheets",
    body: "The tool I needed — now it’s yours.",
  },
  {
    icon: vector4,
    title: "Keep Every Cent You Earn",
    body: "No fees. No hidden cuts. Sell with confidence — every dollar is yours.",
  },
  {
    icon: vector5,
    title: "Work Less, Collect More",
    body: "Add a card once and use it everywhere. Save time and avoid repetitive uploads.",
  },
  {
    icon: vector6,
    title: "Focus on Collecting, Not Managing",
    body: null,
  },
  {
    icon: vector7,
    title: "Find What You Want Instantly",
    body: "Powerful filters and smart search help you skip the endless scrolling and get right to the good stuff.",
  },
  {
    icon: vector8,
    title: "You Keep Every Dollar",
    body: "No platform fees. No surprise cuts. What you sell is yours to keep.",
  },
];

const CardsOptionsSubsection = ({ t }) => {
  return (
    <section className="cards-options" aria-label={t("Cards options")}>
      <header className="cards-options__header">
        <h2 className="cards-options__title">
          {t("Built by a Hockey & Pokémon Collector")}
        </h2>
        <p className="cards-options__subtitle">
          {t(
            "Designed to simplify your hobby — so you can focus on what truly matters: your collection."
          )}
        </p>
      </header>

      <ul className="cards-options__grid">
        {FEATURES.map(({ icon, title, body }, i) => (
          <li className="cards-options__item" key={i}>
            <div className="cards-options__icon" aria-hidden="true">
              <img src={icon} alt="" />
            </div>
            <h3 className="cards-options__item-title">{t(title)}</h3>
            {body && <p className="cards-options__item-text">{t(body)}</p>}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CardsOptionsSubsection;
